<button mat-raised-button color="color" [disabled]="disabled" (click)="onClick()">
  <mat-icon *ngIf="icon">{{icon}}</mat-icon>
  <span *ngIf="label">{{label}}</span>
</button>
